import i18n from 'helpers/i18n';
import messages from './messages';
import React, { useState } from 'react';
import { Button, Modal, ModalProps } from 'semantic-ui-react';
import { cancelTrainingParticipants } from 'actions/trainings';
import { toastError } from 'components/Toast';
import { getApiErrorMessage } from 'helpers/apiError';

interface CancelModalProps extends ModalProps {
  /** Callback fired when the modal requests to be closed. */
  onClose: () => void;

  /** Callback fired after the participants are canceled.  */
  afterCancel: () => void;

  /** Array of participant Ids to be mark as canceled. */
  participantIds: number[];

  /** Training ID. */
  trainingId: number;
}

const CancelModal: React.FC<CancelModalProps> = ({
  trainingId,
  afterCancel,
  participantIds,
  ...props
}) => {
  const [loading, setLoading] = useState(false);

  function handleCancel() {
    setLoading(true);
    cancelTrainingParticipants(trainingId, {
      participant_ids: participantIds
    })
      .then(() => {
        setLoading(false);
        afterCancel();
      })
      .catch(error => {
        toastError({
          description: getApiErrorMessage(error, i18n.ft(messages.errorMessage))
        });
        setLoading(false);
      });
  }

  return (
    <Modal {...props}>
      <Modal.Content>{i18n.ft(messages.areYouSure)}</Modal.Content>
      <Modal.Actions>
        <Button
          disabled={loading}
          onClick={props.onClose}
          content={i18n.ft(messages.dismiss)}
        />
        <Button
          color="red"
          loading={loading}
          disabled={loading}
          onClick={handleCancel}
          content={i18n.ft(messages.cancel)}
        />
      </Modal.Actions>
    </Modal>
  );
};

CancelModal.defaultProps = {
  size: 'small'
};

export default CancelModal;
